import { getUserId } from "./localInfo";

export let checkLogin = () => {
  return getUserId() !== "";
};
